<template>
    <div class="yzjc">
        <div class="yzjcc">
            <div class="gritem" @click="go($event)">
                <div class="gileft">
                    <img width="32px" height="30px" src="../../assets/yzjc/toupiao.png" alt="">
                    <span>决策投票</span>
                </div>
                <div class="giright">
                    <img src="../../assets/yzjc/arrow.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go($event)">
                <div class="gileft">
                    <img width="32px" height="30px" src="../../assets/yzjc/gongshi.png" alt="">
                    <span>公示</span>
                </div>
                <div class="giright">
                    <img src="../../assets/yzjc/arrow.png" alt="">
                </div>
            </div>
            <!-- <div class="gritem" @click="go($event)">
                <div class="gileft">
                    <img width="32px" height="30px" src="../../assets/yzjc/yzwyh.png" alt="">
                    <span>业主委员会</span>
                </div>
                <div class="giright">
                    <img src="../../assets/yzjc/arrow.png" alt="">
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    created () {

    },
    mounted() {
        
    },
    methods: {
        
        go(event){
            var that =this
            var name = event.target.innerHTML
            if(name.indexOf('决策投票') != -1){
                this.$router.push({ path: "/yzjc/jctp", query: {} });
            }
            if(name.indexOf('公示') != -1){
                 this.$router.push({ path: "/yzjc/gs", query: {} });
            }
            // if(name.indexOf('业主委员会') != -1){
            //      this.$router.push({ path: "/yzjc/yzwyh", query: {} });
            // }   
            
        }
    },
}
</script>
<style lang="less">
    .yzjc{
        // height: 100%;
        width: 100%;
        display: flex;
        // background-color: #eeeeee;
        flex-direction: column;
        align-items: center;
        .yzjcc{
            width: calc(100% - 6%);
            .gritem{
                margin-top: 10px;
                height: 60px;
                width: 100%;
                display: flex;
                background: #fff;
                align-items: center;
                border-radius: 10px;
                justify-content: space-between;
                .gileft{
                    display: flex;
                    height: 100%;
                    align-items: center;
                    width: 50%;
                    img{
                        margin-left: 19px;
                    }
                    span{
                        margin-left: 11px;
                        font-size: 16px;
                        color: #666666;
                    }
                }
                .giright{
                    margin-right: 20px;
                    height: 100%;
                    align-items: center;
                    display: flex;
                    flex-direction:row-reverse;
                    img{
						display: block;
						height: 18px;
                        // width: 12px;
					}
                    span{
                        color: #f4f4f4;
                        font-size: 16px;
                        margin-right: 12px;
                   }
                }
            }
        }
    }
</style>